import { createTheme } from "@mui/material";
import { darkThemeOptions, lightThemeOptions } from "@entrilia/shared/theme";

const customizedLightThemeOptions = {
  ...lightThemeOptions,
  components: {
    ...lightThemeOptions.components,
  },
};

const customizedDarkThemeOptions = {
  ...darkThemeOptions,
  components: {
    ...darkThemeOptions.components,
  },
};

const lightTheme = createTheme(customizedLightThemeOptions);
const darkTheme = createTheme(customizedDarkThemeOptions);
const colorSchemeTheme = createTheme({
  colorSchemes: { light: customizedLightThemeOptions, dark: customizedDarkThemeOptions },
  defaultColorScheme: "light",
});

export { lightTheme, darkTheme, colorSchemeTheme };
